import { Box, Separator, Shimmer, ShimmerText } from '@betterment/samba-react';
import { useParentSize } from '@visx/responsive';

import { LoadingAccountProjectionChart } from '../../../../../../../Shared/components-v2/loading-Account-projection-chart/LoadingAccountProjectionChart';

export const ProjectionLoadingState = () => {
  const { parentRef, width } = useParentSize();

  return (
    <Box ref={parentRef} css={{ minWidth: '0px' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
        <Box
          aria-label="Loading..."
          role="status"
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'space.100',
            maxWidth: 'container.small',
          }}
        >
          <ShimmerText
            textStyle="text50"
            css={{
              maxWidth: '60%',
            }}
          />
          <ShimmerText
            textStyle="text400"
            css={{
              maxWidth: '70%',
            }}
          />
        </Box>

        <LoadingAccountProjectionChart width={width} height={220} variant="loading" />
        <Separator />
        <Box css={{ display: 'flex', flexDirection: 'row', gap: 'space.200' }}>
          <Shimmer css={{ width: '40px', height: '40px' }} />

          <ShimmerText textStyle="text25" css={{ maxWidth: '100%' }} />
        </Box>
        <Separator />
        <ShimmerText textStyle="text25" css={{ maxWidth: '100%' }} />
      </Box>
    </Box>
  );
};
